export class ContractInfo {
    id: number;
    contract: string;
    mission: string;
}
